import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AIContext } from '@/modules/AiAgents/context/nugzContext/context';
import { AIActionsTypes } from '@/modules/AiAgents/context/nugzContext/reducer';

import EditIcon from '~/images/shared/edit.svg';

const EditButton = () => {
  const { t } = useTranslation('common');
  const { dispatch } = useContext(AIContext);

  const handleEdit = () => {
    dispatch({
      type: AIActionsTypes.setIsEditing,
      payload: true,
    });
  };

  return (
    <div
      className='flex cursor-pointer items-center gap-1 rounded-xl border-sm border-outline-default px-16 py-2 text-base font-semi-bold text-primary-default'
      onClick={handleEdit}
    >
      <span className='text-24'>
        <EditIcon />
      </span>
      <span>{t('edit-table')}</span>
    </div>
  );
};

export { EditButton };
